import {
  SeaAllFilterField,
  useTagActions,
} from '@aibees/elephant/components/see-all-popup';
import { Tags } from '@aibees/elephant/components/tags';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { ROUTES } from '@aibees/elephant/router';
import { Icon } from '@aibees/shared/components';
import { useMatchRoute } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NaicsTagsProps as Props } from './types';
import { useNaicsTags } from './use-naics-tags';

export const NaicsTags = memo(({ className, title, icon }: Props) => {
  const { api } = useCompanyReadDataContext();
  const items = useNaicsTags(api?.data?.naics);

  const isPeoplePage = useMatchRoute(ROUTES.people);
  const isCompanyPage = useMatchRoute(ROUTES.company);

  const actions = useTagActions();
  const limitCount = useMemo(() => {
    if (isPeoplePage || isCompanyPage) {
      return items?.length ?? 0;
    }

    return 3;
  }, [isPeoplePage, isCompanyPage, items?.length]);

  return (
    <Styled.Wrapper className={classnames('NaicsTags', className)} sx={SX.root}>
      <Stack direction="row" alignItems="center" gap={1}>
        {<Icon name={icon || '10-plus'} color="grey.500" size={18} />}

        <Typography variant="body4" color="grey.700" fontWeight={400}>
          {title || 'NAICS Code'}
        </Typography>
      </Stack>

      <Tags
        key="naics-tags"
        items={items}
        limit={limitCount}
        config={{
          actions,
          includeSearch: 'naics_include_any',
          excludeSearch: 'naics_exclude_any',
          field: SeaAllFilterField.naics,
          placeholder: 'Search NAICS Code Tags',
        }}
        icon="10-plus"
        title="NAICS Code Tags"
      />
    </Styled.Wrapper>
  );
});

NaicsTags.displayName = 'NaicsTags';
